import script from "./MediaflowItem.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaflowItem.vue?vue&type=script&setup=true&lang=js"

import "./MediaflowItem.vue?vue&type=style&index=0&id=48a8b1c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48a8b1c8"]])

export default __exports__